module.exports = __webpack_public_path__ + "img/style2.2ee8f68c.png";